import { ParticipantView, StreamVideoParticipant } from '@stream-io/video-react-sdk';
import { VideoPlaceholder } from './video-placeholder';
import { CustomParticipantViewUIMyself } from './custom-participant-view-uI';

type Props = {
  participant?: StreamVideoParticipant;
};

export const FloatingLocalParticipant = ({ participant }: Props) => {
  if (!participant) return <></>;

  return (
    <div
      className="absolute z-9999999999 top-[15px] right-[15px] w-[120px] lg:w-[240px] lg:h[135px]"
      style={{
        boxShadow: 'rgba(0, 0, 0, 0.1) 0px 0px 10px 3px',
        borderRadius: '12px',
      }}
    >
      <ParticipantView
        participant={participant}
        VideoPlaceholder={() => <VideoPlaceholder size="small" />}
        ParticipantViewUI={() => <CustomParticipantViewUIMyself />}
        trackType="videoTrack"
      />
    </div>
  );
};
